import React from "react";
import "./PrivacyPolicy.css"; // Use the same CSS

function TermsOfService() {
  return (
    <div className="legal-container">
      <h1>Terms of Service</h1>
      <div className="legal-content">

        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing or using Pipelyze, you agree to these Terms of Service. If you do not agree, please do not use our services.
        </p>

        <h2>2. Use of Service</h2>
        <ul>
          <li>You must provide accurate information when creating an account.</li>
          <li>You are responsible for maintaining the security of your account credentials.</li>
          <li>You may not use Pipelyze for unlawful or unauthorized purposes.</li>
        </ul>

        <h2>3. Subscription and Payments</h2>
        <p>
          All payments are processed securely via Stripe. You are responsible for all subscription fees associated with your chosen plan.
        </p>

        <h2>4. Intellectual Property</h2>
        <p>
          All content and software provided by Pipelyze remain our intellectual property. You may not copy, modify, or distribute our content without permission.
        </p>

        <h2>5. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your account for violations of these terms or for any reason at our sole discretion.
        </p>

        <h2>6. Limitation of Liability</h2>
        <p>
          Pipelyze is provided "as is" without warranties of any kind. We are not liable for any damages arising from your use of our services.
        </p>

        <h2>7. Changes to Terms</h2>
        <p>
          We may update these Terms of Service. Continued use of Pipelyze constitutes your acceptance of any changes.
        </p>

        <h2>8. Contact</h2>
        <p>
          For questions, contact us at <a href="mailto:support@pipelyze.com">support@pipelyze.com</a>.
        </p>

        <div className="legal-footer">Last updated: July 20, 2025</div>
      </div>
    </div>
  );
}

export default TermsOfService;
